(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-pet-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ws-pet-gallery')) {
    customElements.define('ws-pet-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('[data-pet-gallery-rail]');
        this.controls = this.querySelector('[data-pet-gallery-controls]');
        this.previous = this.querySelector('[data-pet-gallery-previous]');
        this.next = this.querySelector('[data-pet-gallery-next]');

        this.addEventListener('shopify:block:select', (event) => {
          this.hideEditorNotes();
          const item = event.target.closest('.ws-pet-gallery__case, [data-pet-gallery-editor-note]');
          if (!item || !this.contains(item)) return;
          item.hidden = false;
          item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.addEventListener('shopify:block:deselect', () => this.hideEditorNotes(), options);

        if (!this.rail) return;
        this.rail.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.previous.addEventListener('click', () => this.advance(-1), options);
        this.next.addEventListener('click', () => this.advance(1), options);
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.rail);
        this.updateControls();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      hideEditorNotes() {
        this.querySelectorAll('[data-pet-gallery-editor-note]').forEach((note) => { note.hidden = true; });
      }

      scheduleUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateControls());
      }

      updateControls() {
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const position = Math.max(0, Math.min(maximum, Math.abs(this.rail.scrollLeft)));
        this.controls.hidden = maximum < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = maximum - position < 2;
      }

      advance(direction) {
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = this.rail.firstElementChild.getBoundingClientRect().width + gap;
        const flow = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
        this.rail.scrollBy({
          left: direction * flow * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-product-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ws-copy-email')) {
    customElements.define('ws-copy-email', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-copy-address]');
        this.fallback = this.querySelector('[data-copy-fallback]');
        this.status = this.querySelector('[role="status"]');
        if (!this.button || !this.fallback || !this.status) return;
        this.controller?.abort();
        this.controller = new AbortController();
        this.button.hidden = false;
        this.fallback.hidden = true;
        this.button.addEventListener('click', () => this.copy(), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.resetTimer);
      }

      async copy() {
        if (this.copying) return;
        this.copying = true;
        clearTimeout(this.resetTimer);
        this.status.textContent = '';
        let copied = false;
        try {
          await navigator.clipboard.writeText(this.button.dataset.copyAddress);
          copied = true;
        } catch {
          copied = this.copyFallback();
        }
        this.copying = false;
        if (!this.isConnected) return;
        this.status.textContent = copied ? this.dataset.copied : this.dataset.failed;
        this.resetTimer = setTimeout(() => { this.status.textContent = ''; }, 2000);
      }

      copyFallback() {
        const input = document.createElement('textarea');
        input.value = this.button.dataset.copyAddress;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;inset:0;opacity:0;pointer-events:none;font-size:16px';
        const selection = window.getSelection();
        const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
        const focused = document.activeElement;
        let copied = false;
        try {
          document.body.append(input);
          input.select();
          input.setSelectionRange(0, input.value.length);
          copied = document.execCommand('copy');
        } catch {
          copied = false;
        } finally {
          input.remove();
          if (focused?.isConnected) focused.focus({ preventScroll: true });
          if (selection) {
            selection.removeAllRanges();
            ranges.forEach((range) => selection.addRange(range));
          }
        }
        return copied;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
